export default "__VITE_ASSET__D1T0O8$a__"